module.exports = __webpack_public_path__ + "img/Sale-Item-Ribbon.b0258a28.svg";